import script from "./Dash.vue?vue&type=script&setup=true&lang=js"
export * from "./Dash.vue?vue&type=script&setup=true&lang=js"

import "./Dash.vue?vue&type=style&index=0&id=c360a930&lang=scss&scoped=true"

import exportComponent from "/Users/sam/WebDev/Projects/debtnote/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c360a930"]])

export default __exports__